export default class Listing {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.accordion();
    }
    accordion() {
        this.el.addEventListener('click', (e) => {
            if (e.target.closest('.listing__accordion-toggle')) {
                let el = e.target;
                if (el.closest('.module-listing--layout-1') !== null) {
                    if (el.classList.contains('listing__accordion-toggle--active')) {
                        this.el.querySelectorAll('.listing__accordion-toggle').forEach((el) => {
                            el.classList.remove('listing__accordion-toggle--active');
                        });
                    } else {
                        this.el.querySelectorAll('.listing__accordion-toggle').forEach((el) => {
                            el.classList.remove('listing__accordion-toggle--active');
                        });
                        el.classList.add('listing__accordion-toggle--active');
                    }
                }
            }
        });

        let accordion_toggles = document.querySelectorAll('.listing__accordion-toggle');
        if (accordion_toggles.length > 0) {
            accordion_toggles.forEach((toggle) => {
                toggle.addEventListener('keyup', (e) => {
                    if (e.key === 'Enter') {
                        if (toggle.classList.contains('listing__accordion-toggle--active')) {
                            toggle.classList.remove('listing__accordion-toggle--active');
                        } else {
                            toggle.classList.add('listing__accordion-toggle--active');
                        }
                    }
                });
            });
        }
    }
}
